import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteRegularClassSchedules = ({ id }) => {
  return api.delete(`/admin/regular-class-schedules/${id}`);
};

export const useDeleteRegularClassSchedules = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteRegularClassSchedules,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.invalidateQueries({
        queryKey: ["regular-class-schedules"],
      });
    },
    ...restConfig,
  });
};
